
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports/signup",
      function () {
        return require("private-next-pages/reports/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reports/signup"])
      });
    }
  